import React from 'react';
import BannersFetcher from '../../common/BannersFetcher';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { useHandleSeoSettings } from '../../data/seo/seoUtils';
import { getConfiguration } from '../../data/utils/configuration';
import { labels } from '../../data/labels';
import { PrematchContext } from '../Prematch';
import SportCollapse from './SportCollapse';
import LiveTv from '../../common/live-tv/LiveTv';

function LandingSports(props) {
    const conf = getConfiguration();
    const prematchContext = React.useContext(PrematchContext);
    const sports = props.sport ? [props.data.sportById[props.sport.id]] : props.data.sport;
    const seoContext = React.useContext(SeoContext);
    //const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname,true,conf.seo);

    //useHandleSeoSettings(seoSettingsState);

    function openExtraEvents(e) {
        e.preventDefault();
        e.stopPropagation();
        prematchContext.openExtraEvents();
    }

    return (
        <>
            <SeoMetaTags />
            {props.data.showIncreasedOddsButton &&
            	<a className="sport-anchor" href="" onClick={openExtraEvents}>
                    <div className="list-element sport-collapse">
                        <div className="prematch-sport-img big"></div>
                        <span className="list-element-text list-heading">{labels['prematch.extra_events.title']}</span>
                        <div className="d-flex push-right mr-2">
                            <span className="list-element-info"></span>
                        </div>
                        <span className="arrow arrow-right"></span>
                    </div>
                </a>
            } 
            {!conf.mbep &&
                <BannersFetcher />
            }
            <LiveTv container='landing' />
            {prematchContext.applyTemporalFilter(sports).map(sport => {
                return <SportCollapse key={sport.id} sport={sport} showDesc={!props.sport} />
            })}
            <SeoMainContainer />
        </>
    );
}

export default LandingSports;